import React from "react";
import { NavLink } from "react-router-dom";

function SideBar() {
  return (
    <>
      <h1 className="h2 pb-4">Categories</h1>
      <ul className="list-unstyled templatemo-accordion">
        <li className="pb-3">
          <NavLink
            className="collapsed d-flex justify-content-between h3 text-decoration-none"
            to="/shop"
          >
            Gender
            <i className="fa fa-fw fa-chevron-circle-down mt-1"></i>
          </NavLink>
          <ul className="collapse show list-unstyled pl-3">
            <li>
              <NavLink className="text-decoration-none" to="/shop">
                Men
              </NavLink>
            </li>
            <li>
              <NavLink className="text-decoration-none" to="/shop">
                Women
              </NavLink>
            </li>
          </ul>
        </li>
        <li className="pb-3">
          <NavLink
            className="collapsed d-flex justify-content-between h3 text-decoration-none"
            to="/shop"
          >
            Sale
            <i className="pull-right fa fa-fw fa-chevron-circle-down mt-1"></i>
          </NavLink>
          <ul id="collapseTwo" className="collapse list-unstyled pl-3">
            <li>
              <NavLink className="text-decoration-none" to="/shop">
                Sport
              </NavLink>
            </li>
            <li>
              <NavLink className="text-decoration-none" to="/shop">
                Luxury
              </NavLink>
            </li>
          </ul>
        </li>
        <li className="pb-3">
          <NavLink
            className="collapsed d-flex justify-content-between h3 text-decoration-none"
            to="/shop"
          >
            Product
            <i className="pull-right fa fa-fw fa-chevron-circle-down mt-1"></i>
          </NavLink>
          <ul id="collapseThree" className="collapse list-unstyled pl-3">
            <li>
              <NavLink className="text-decoration-none" to="/shop">
                Bag
              </NavLink>
            </li>
            <li>
              <NavLink className="text-decoration-none" to="/shop">
                Sweather
              </NavLink>
            </li>
            <li>
              <NavLink className="text-decoration-none" to="/shop">
                Sunglass
              </NavLink>
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
}

export default SideBar;
